export default {
    Comm:{
        back:"Back",
        fbsj:'Release Time',
        bah:'冀ICP备18005127号'
    },
    Nav: {
        sy: 'Home',
        gywm: 'About\nUs',
        gywm_gsjj: "Company Profile",
        gywm_gsry: "Company Honors",
        gywm_gssq: "Company Video",
        gywm_gswz: "Address",
        gywm_qywh: "Corporate Culture",
        gywm_shzr: "Social Responsibility",
        // cpyfw:'Products Services',
        cpyfw: 'Products',
        cpyfw_cpml: 'Product Catalog',
        cpyfw_gylx: 'Routing',
        cpyfw_jscb: 'Technical Reserve',
        cpyfw_zzrz: 'Qualification',
        cpyfw_zlhzhb: 'Strategic Partners',
        cpyfw_yxwl: 'Marketing network',
        // jsyf:'Technology R&D',
        jsyf: 'Technology',
        jsyf_yfdw: 'R&D Team',
        jsyf_yqhz: 'Institute Cooperation',
        jsyf_yfcg: 'R&D Achievements',
        jsyf_zlbz: 'Patent Standards',
        xwzx: 'News',
        lshb: 'Environmental',
        // lshb:'Environmental',
        djyd: 'Party\nBuilding',
        // djyd:'Party',
        djyd_xxyw: 'Learning ',
        djyd_jbgk: 'Basic',
        djyd_dqdt: 'Dynamics',
        djyd_ghzc: 'Trade Union Window',
        // zpzx:'Recruitment Center',
        zpzx: 'Recruitment',
        lxwm: 'Contact\nUs',
        wxgxh:'Scan WeChat and follow us',
        wx_jljt:'Jianlong Group',
        wx_cdjl:'Chengde Jianlong'
    },
    home: {
        pName: 'Chengde Jianlong Special Steel Co., Ltd',
        dizhi: 'Address: Chengde Jianlong Steel Co., Ltd., Ping\'anbao Town, Xinglong County',
        youbian: 'Postal code：067300',
        xsdh: 'Sales Phone：0314-5316280',
        xzdh: 'Administrative Phone：0314-5316013',
        bqsy: 'Copyright：Chengde Jianlong Special Steel Co., Ltd',
        jszc: 'Technical Support：Chengde Jianlong Special Steel Co., Ltd',
        home11: 'Environmental Protection Series',
        home12: 'Chengde Jianlong follows the safety and environmental protection concept of "cherishing life and the environment" and takes the path of sustainable development. Focusing on "ultra-low emissions of pollutants, green and low-carbon", we will use advanced governance technology to achieve the minimization, harmlessness, and recycling of pollutant emissions through digital, intelligent, and refined management and control means, and finally achieve a green enterprise that is scientific and technological leader, low-carbon and environmental protection.',
        home21: 'Make Products Well',
        home22: 'In recent three years, it has won three metallurgical science and technology awards from China Iron and Steel Industry Association, one Beijing Science and Technology Progress Award, and six Hebei Metallurgical Science and Technology Awards. Among them, the overall achievement of the project "Multi process Collaborative Control Technology and Application of Ultra Low Oxygen Free Cutting Gearbox Gear Steel" has reached the international advanced level and won the second prize of Metallurgical Science and Technology of China Iron and Steel Association ',
        home31: 'Modern Techniques',
        home32: 'The company has long focused on science and technology leading and innovation driving, established long-term cooperation with well-known universities such as Beijing University of Science and Technology, Northeast University, Shanghai University, Central South University, and carried out a number of cooperative research and development projects, paying about 6 million yuan of cooperation funds annually. On May 26, 2021, Academician Qiu Guanzhou of Central South University was invited to establish the Academician Workstation of Chengde Jianlong Special Steel Co., Ltd.',
        home41: 'Responsibility And Give Back Society',
        home42: 'Adhering to the safety and environmental concept of "cherishing life and the environment", Chengde Jianlong has made great contributions to infrastructure construction and environmental protection. First, industry city integration. Since 2017, a total of 54 million yuan has been invested to build 1 # and 2 # blast furnace slag flushing water heat exchange stations, which have solved the winter heating problem for more than 3300 surrounding villagers in Ping\'an New Area and Ping\'an Mining, covering an area of nearly 700000 square meters, contributing to reducing carbon emissions',
        homeMore: 'More >>'
    },
    product: {
        mulu01: 'Round Billet',
        mulu02: 'Steel Pipe',
        mulu03: 'Round Tube',
        mulu04: 'Vanadium Products'
    },
    recruit:{
        zp1:'Campus Recruitment',
        zp2:'General Recruitment',
        zp3:'Positions Open',
        tip1:"Department",
        tip2:"Post",
        tip3:"Education",
        tip4:"Major",
        tip5:"More",
        tip6:"More Info"
    }
};
